import { render } from "./App.vue?vue&type=template&id=78011b8c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=78011b8c&lang=css"

import exportComponent from "D:\\Adro\\qr\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__